import { useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { AppContext } from 'core/context/app.context';
import { HaptikLaunchMessage } from 'core/enums/haptik-launch-messages';
import { Util } from 'utils/common.utils';
import InstructionsCard from './instructions-card';
import { PopupStore } from '../../popup.store';

const UnlockSimInfo = ({ popupStore }: { popupStore: PopupStore }) => {
  const navigate = useNavigate();
  const { agreementId } = useParams();
  const appContext = useContext(AppContext);

  const handleChatToAgent = () => {
    appContext?.haptikStore.showApp(HaptikLaunchMessage.HaptikChatToAgent);
    popupStore.defaultClose();
  };

  return (
    <div className="cust-mt-4">
      <InstructionsCard
        icon="icon-wifi-connection_32px"
        title="product.internet.unlockSimModal.deviceCompatibility"
        description="product.internet.unlockSimModal.deviceCompatibilityDesc"
        buttonText="buttons.viewDevices"
        action={() => {
          window.open(`${Util.BaseUrl}/${appContext.locale}/faqs/services/dstv-internet/`, '_blank');
        }}
      />
      <InstructionsCard
        icon="icon-wifi_32x32"
        title="product.internet.unlockSimModal.changeLocation"
        description="product.internet.unlockSimModal.changeLocationDesc"
        buttonText="buttons.updateLocation"
        action={() => {
          navigate(`/action?action=internet-update-location&id=${agreementId}`);
        }}
      />
      <InstructionsCard
        icon="icon-usage-address"
        title="product.internet.unlockSimModal.noSignal"
        description="product.internet.unlockSimModal.noSignalDesc"
        buttonText="buttons.speakToAgent"
        action={handleChatToAgent}
      />
    </div>
  );
};

export default UnlockSimInfo;